<template>
  <div class="MediGridItemVimeo">

    <template v-if="data.route || data.hash">

      <vimeo-thumbnail v-bind="data" />

    </template>

    <template v-else>

      <vimeo v-bind="data" />

    </template>

    <media-grid-item-title :data="data" />

    <media-grid-item-description :data="data" />

  </div>
</template>

<script>
export default {
  name: 'MediGridItemVimeo',

  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>
.MediGridItemVimeo {

}
</style>



// WEBPACK FOOTER //
// MediaGridItemVimeo.vue?2ac65b17